<template>
	<div >
		<div class="ft20 cl-black cl-main ftw500">充值记录</div>

		<div class="mt20">
			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="充值类型">
						<a-select v-model="search.pay_type" style="width: 120px;">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option :value="1">用户微信充值</a-select-option>
							<a-select-option :value="2">后台充值</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item label="会员昵称">
						<a-input v-model="search.nick_name" placeholder="请输入会员昵称"></a-input>
					</a-form-item>

					<a-form-item label="会员手机号">
						<a-input v-model="search.mobile" placeholder="请输入会员手机号"></a-input>
					</a-form-item>

					<a-form-item label="操作日期">
						<a-range-picker @change="changeOperateTime" v-model="search.operate_time" valueFormat="YYYY-MM-DD" />
					</a-form-item>
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
		</div>

		<div class="mt20">
			<div class=" " style="min-height: 500px;">
				<div class="wxb-table-white">
					<a-table rowKey="member_balance_logs_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
					 :loading="loading">

						<div class="flex alcenter center" slot="member_id" slot-scope="record">
							{{record.member != null ? record.member.member_id : '-'}}
						</div>
					 
						<div  slot="member" slot-scope="member,record">
							<div v-if="member != null" class="flex alcenter center">
								<img v-if="member.face!=null" :src="member.face" class="member-money-recharge-face" />
								<img v-else src="../../assets/image/woyaoyou_head_defult@2x.png" class="member-money-recharge-face" />
								<div class="ml5" style="text-align: left;">
									<div>{{member.nick_name}}</div>
									<div class="mt2">{{member.mobile}}</div>
								</div>
							</div>
							<div v-else>-</div>
						</div>
 
						<div class="text-center" slot="pay_type" slot-scope="pay_type,record">
							<div v-if="pay_type== 1">用户微信充值</div>
							<div v-else-if="pay_type== 2">后台充值</div>
							<div v-else>-</div>
						</div>

						<div class="text-center" slot="is_paid" slot-scope="is_paid,record">
							<div v-if="is_paid== 1">已支付</div>
							<div v-else>未支付</div>
						</div>

						<div class="text-center" slot="refund_fee" slot-scope="refund_fee,record">
							<div style="color:red;" v-if="refund_fee > 0">{{refund_fee}}</div>
							<div v-else>{{refund_fee}}</div>
						</div>
						
						<div class="text-center" slot="mendian" slot-scope="mendian,record">
							{{mendian ? mendian.name : '-'}}
						</div>

						<div class="text-center" slot="operator" slot-scope="record">
							<div v-if="record.operate_name && record.operate_mobile">
								<div class="ft14 cl-info">{{record.operate_name}}</div>
								<div class="ft12 cl-notice">({{record.operate_mobile}})</div>
							</div>
							<div v-else>-</div>
						</div>

						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay" v-if="record.is_refund == 0">
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="sureRefund(record)">
												<span>退款</span>
											</a>
										</a-menu-item>
										
										<!-- <a-menu-item v-if="buttons.get.value==1">
											<a class="menu-act" href="javascript:;" @click="see(record)">
												<span>查看</span>
											</a>
										</a-menu-item> -->

									</a-menu>
								</a-dropdown>
							</div>
						</template>
					</a-table>
				</div>
			</div>
			
			<!-- <a-layout>
				<a-layout-header class="layout-classes-header">
					<a-menu class="classes-menu" :defaultSelectedKeys="[selectCurrent]" @click="selectMenu" mode="horizontal">
						<a-menu-item key="recharge">充值记录</a-menu-item>
						<a-menu-item key="consume">消耗记录</a-menu-item>
					</a-menu>
				</a-layout-header>
				<a-layout-content class="layout-classes-content">
					<div v-if="selectCurrent == 'recharge'">
						<money-recharge :search="search" ref="mychild"></money-recharge>
					</div>
					<div v-if="selectCurrent == 'consume'">
						<money-consume :search="search" ref="mychild"></money-consume>
					</div>
					
				</a-layout-content>
			</a-layout> -->
		</div>
	</div>
</template>

<script>
	import {
		listMixin
	} from '../../common/mixin/list.js';
	export default {
		mixins: [listMixin],
		data() {
			return {
				loading: false,
				search: {
					nick_name: '',
					mobile: "",
					operate_time:['',''],
					pay_type:0
				},
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				columns: [
					{title: '充值单号',dataIndex: 'out_trade_no',align: 'center',ellipsis: true,width:200},
					{title: '充值金额',dataIndex: 'recharge_price',align: 'center'},
					//{title: '赠送的金额',dataIndex: 'give_price',align: 'center',scopedSlots: {customRender: 'give_price'}},
					{title: '会员',dataIndex: 'member',align: 'center',scopedSlots: {customRender: 'member'},width:200},
					{title: '类型',dataIndex: 'pay_type',align: 'center',scopedSlots: {customRender: 'pay_type'}},
					{title: '支付状态',dataIndex: 'is_paid',align: 'center',scopedSlots: {customRender: 'is_paid'}},
					{title: '支付时间',dataIndex: 'pay_time_format',align: 'center',ellipsis: true,width:160},
					{title: '退款金额',dataIndex: 'refund_fee',align: 'center',scopedSlots: {customRender: 'refund_fee'}},
					{title: '所属门店',dataIndex: 'mendian',align: 'center',scopedSlots: {customRender: 'mendian'}},
					{title: '操作人',key: 'operator',align: 'center',scopedSlots: {customRender: 'operator'}},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true,width:160},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
				
			}
		},
		methods: {
			
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getMemberBalanceOrderList',{
					pay_type:this.search.pay_type,
					nick_name:this.search.nick_name,
					mobile:this.search.mobile,
					operate_time:this.search.operate_time,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			
			changeOperateTime(){
				this.search.operate_time=value;
			},
			
			searchCancel() {
				this.search = {
					nick_name: '',
					mobile: "",
					operate_time:['',''],
				};
			},
			searchAct(){
				this.getLists();
			},
			cancelAct(){
				this.searchCancel();
				this.searchAct();
			},

			// 确认退款
			sureRefund(item){
				// 显示确认弹框
				this.$confirm({
					title: '确定退款吗？',
					content: '1.用户微信充值将发起微信退款，并且扣除用户相应的余额。2.后台充值只扣除用户相应的余额。',
					okText: '确认',
					cancelText: '取消',
					type: 'warning',
					onOk: () => {
						// 用户点击确认后执行的操作
						this.$http.api('admin/balanceOrderRefund',{
							order_id:item.order_id,
						}).then(res=>{
							this.$message.success('操作成功',1,()=>{
								// 重新获取列表数据
								this.getLists();
							});
						}).catch(res=>{
							console.log(res);
						})
					},
					onCancel: () => {
						// 用户点击取消，什么都不做
						console.log('用户取消操作');
					}
				});
			},
		}
	}
</script>

<style>
	.layout-classes-header {
		background: #FFFFFF;
	}
	
	.layout-classes-header {
		padding: 0 20px;
		height: 58px;
		line-height: 57px;
		border-bottom: 1px solid #F0F3F5;
		width: 100%;
	}
	
	.layout-classes-content {
		padding: 0px 0px 10px 0px;
		background: #FFFFFF;
		width: 100%;
		min-height: 700px;
	}
	
	.classes-menu {
		border-bottom: none;
		line-height: 55px;
		font-size: 14px;
	}
	
	.member-money-recharge-face {
		width: 44px;
		height: 44px;
		border-radius: 44px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
		border: 2px solid #FFFFFF;
	}
</style>
